/* SEO traffic is currently defined as:
  - Google search as the referer
*/

export const isSeoTraffic = (referer?: string): boolean => {
  if (!referer) return false;
  const url = new URL(referer);
  return url.hostname.includes('google');
};
